module.exports = __webpack_public_path__ + "img/leaf.0f4e7280.png";